<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="44"
    viewBox="0 0 45 44"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.1 34.8309C10.2136 34.8309 3.00977 27.6068 3.00977 18.6955C3.00977 9.78412 10.2136 2.56006 19.1 2.56006C27.9865 2.56006 35.1903 9.78412 35.1903 18.6955C35.1903 22.3474 33.9804 25.7161 31.9407 28.4202L41.2618 37.7674C42.0996 38.6076 42.0996 39.9698 41.2618 40.8099C40.424 41.6501 39.0656 41.6501 38.2278 40.8099L28.9213 31.4774C26.2041 33.5801 22.7977 34.8309 19.1 34.8309ZM19.1003 30.5281C25.617 30.5281 30.8998 25.2304 30.8998 18.6955C30.8998 12.1605 25.617 6.86283 19.1003 6.86283C12.5836 6.86283 7.30076 12.1605 7.30076 18.6955C7.30076 25.2304 12.5836 30.5281 19.1003 30.5281Z"
      fill="#3F3F3F"
    />
  </svg>
</template>
